import React, { useEffect, useState } from 'react';
import MostrarResultados from '../componentes/MostrarResultados';
import { socket } from '../socket';

const ResultadosSalto = () => {

    const [aparato, setAparato] = useState('');
    const [results, setResults] = useState([]);
    const [nivel, setNivel] = useState('');
    const [categoria, setCategoria] = useState('');
    
    useEffect(() => {
        socket.on('saltoresult', data => {
            console.log('Salto result received:', data);
            if (data.aparato === 'Salto' && data.results.length > 0 ) {
                setAparato(data.aparato);
                setResults(data.results);
                setNivel(data.nivel);
                setCategoria(data.categoria);
            }
        });
    }, []);
    
    console.log("here");
    return (
        <div>
            <MostrarResultados aparato={aparato} results={results} nivel={nivel} categoria={categoria}/>
        </div>
    );
};

export default ResultadosSalto;